import getApiClient from "../../../plugins/api";

export default {
    updateAccount: function(type) {
        const self = this,
            api = getApiClient(self.$root.$store)

        self.$store.commit('startLoading')
        self.successResponse = ''
        self.errorResponse = ''
        self.resetErrors()

        let component = (type === 'users' ? self.$refs.customer : self.$refs.agency),
            postData = self.transformData(Object.assign({}, component.user))

        api.patch(`/${type}/${component.user.id}`, postData, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then((result) => {
                self.$parent.currentUser = result.data
                self.$parent.currentUser.roles = result.data.roles
                component.loadData()
                self.successResponse = 'Dados atualizados com sucesso'
            })
            .catch((error) => {
                self.errorResponse = 'Não foi possível atualizar seus dados'
                let responseData = error.response.data

                if (responseData.violations) {
                    responseData.violations.forEach((violation) => {
                        self.errors[violation.propertyPath] = violation.message
                    })
                }
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    transformData: function(data) {
        let numericFields = [
            'phone',
            'contactPhone',
            'cpf',
            'zipCode',
            'cnpj',
            'cadastur'
        ]
        for (let field in numericFields) {
            let fieldName = numericFields[field]

            if (data[fieldName] !== undefined) {
                data[fieldName] = data[fieldName].replace(/[^0-9]/g, '')
            }
        }

        let noPunctuationFields = [
            'rg'
        ]

        for (let field in noPunctuationFields) {
            let fieldName = noPunctuationFields[field]

            if (data[fieldName] !== undefined) {
                data[fieldName] = data[fieldName].replace(/[^A-z0-9]/g, '')
            }
        }

        if (data['agency']) {
            data['agency']['id'] = data['agency']['@id']
        }

        return data
    },

    resetErrors: function() {
        this.errors = {
            name: null,
            cnpj: null,
            cadastur: null,
            email: null,
            password: null,
            image: null,
            cover: null,
            currentImage: null,
            birthDate: null,
            phone: null,
            gender: null,
            rg: null,
            cpf: null,
            zipCode: null,
            state: null,
            city: null,
            address: null,
            addressNumber: null,
            addressNeighbourhood: null,
            contactName: null,
            contactPhone: null,
            pixKey: null,
            'agency.description': null
        }
    }
}
